import { render } from "./MaintananceComponent.vue?vue&type=template&id=5aad09e6"
import script from "./MaintananceComponent.vue?vue&type=script&lang=js"
export * from "./MaintananceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__